export default "__VITE_ASSET__Dr2vwTzs__"